<!-- 閉じたら配列から外す。track を $index にすると、閉じて非表示になった p-message が次のメッセージに使い回される -->
@for (m of messages; track m) {
  <p-message
    [severity]="m.severity"
    [closable]="true"
    (onClose)="messages.splice($index, 1)"
    variant="outlined">
    <b>{{ m.summary }}</b>
    {{ m.detail }}
  </p-message>
}
